import React from 'react'
import {
  DialogComponent
} from '../../shared/dialog/dialog.component'
import InputMask from 'react-input-mask'
import { superagent } from '../../shared/superagent/superagent';
import singletons from '../../shared/singletons'
import { loginApi } from './login_api'
import { CheckBoxComponent } from '../../shared/checkbox/checkbox.component'

import { sharedData } from '../../../models/shared_data'

export class LoginDialog extends React.Component {

  constructor(props) {
    super(props)
    this.state = {
      state: 'login',
      sending_sms: false,
      agrees: {},
      params: {
        phone: (props.phone ? props.phone : ''),
        code: ''
      },
      timer_seconds: 60,
      errors: {}
    }

    this.timerSendingCode = null

    this.makeLogin = this.makeLogin.bind(this)
    this.requestRecover = this.requestRecover.bind(this)
    this.register = this.register.bind(this)

    this.sendCode = this.sendCode.bind(this)
    this.login = this.login.bind(this)
    this.cancelCode = this.cancelCode.bind(this)
    this.refreshCode = this.refreshCode.bind(this)
  }

  componentDidMount() {
    this.phoneWrapperRef.querySelector('input').focus();
  }

  isValidPhone() {
    const phone = this.state.params.phone.replace(/\D/g,'');
    return phone.length == sharedData.phone_length
  }

  canRefreshCode() {
    return this.state.timer_seconds == 60
  }

  canSubmitCode() {
    return this.state.params.code.length > 1
  }

  startTimerInterval() {
    this.setState({timer_seconds: 59}, ()=> {
      this.timer = setInterval(()=> {
        this.setState((ps)=> {
          if(ps.timer_seconds > 0) {
            ps.timer_seconds -= 1
          } else {
            this.clearRefreshCodeInterval()
            ps.timer_seconds = 60
          }
          return ps
        })
      }, 1000)
    })
  }

  clearRefreshCodeInterval() {
    if(this.timer) {
      clearInterval(this.timer)
      this.timer = null
    }
  }

  sendCode(e) {
    e.preventDefault()
    if(!this.isValidPhone() || !this.consentsOk())
      return
    this.setState({
      sending_sms: true
    })

    this.startTimerInterval()
    loginApi.sendCode(this.state.params.phone)
      .subscribe(()=> {
        this.codeRef.focus()
      })
  }

  refreshCode(e) {
    e.preventDefault()
    this.startTimerInterval()
    loginApi.refreshCode(this.state.params.phone)
      .subscribe(()=> {

      })
  }

  cancelCode(e) {
    e.preventDefault()
    this.clearRefreshCodeInterval()

    this.setState({
      sending_sms: false,
      params: {
        phone: '',
        code: ''
      }
    })
  }

  login(e) {
    e.preventDefault()
    if(!this.canSubmitCode())
      return
    this.setState({
      errors: {}
    })
    singletons['loading'].start()
    superagent.post("/api/login")
      .send(this.state.params)
      .end((err, resp)=> {
        const data = resp.body

        if(data.status == 'ok') {
          sharedData.updateData(data.shared_data)
          if(this.props.reload) {
            window.location.reload()
          }
          else {
            singletons['loading'].stop()
          }
          //
          // singletons['login'].close()
        } else {
          singletons['loading'].stop()
          this.setState({
            errors: {
              code: true
            }
          })
        }
      })
  }

  isError(name) {
    if(this.state.errors[name])
      return 'error'
    return ''
  }

  makeLogin(e) {
    e.preventDefault()
    // console.log('here!')
  }

  requestRecover(e) {
    e.preventDefault()
    // console.log('here!')
  }

  register(e) {
    e.preventDefault()
    // console.log('here!')
  }

  changeParams(name, e) {
    e.preventDefault()

    const v = e.target.value
    this.setState((ps)=> {
      ps.params[name] = v
      return ps
    })
  }

  toState(st, e) {
    e.preventDefault()
    this.clearRefreshCodeInterval()
    this.setState({
      state: st
    })
  }

  getConsentItems() {
    const sp = (sharedData.data && sharedData.data.site_params) || {}
    const items = (sp.site_consent_checkboxes && sp.site_consent_checkboxes.length > 0)
      ? sp.site_consent_checkboxes
      : [{
          text: 'Я даю согласие на обработку моих персональных данных в соответствии с',
          link_title: 'Политикой обработки персональных данных и политикой конфиденциальности',
          link_url: '/conds',
          is_required: true,
          default_checked: true
        }]
    return items
  }

  isAgreed(idx) {
    if (this.state.agrees[idx] === undefined) {
      const item = this.getConsentItems()[idx]
      return !!(item && item.default_checked)
    }
    return this.state.agrees[idx] === true
  }

  toggleAgree(idx) {
    const next = !this.isAgreed(idx)
    this.setState((ps)=> {
      ps.agrees[idx] = next
      return ps
    })
  }

  consentsOk() {
    const items = this.getConsentItems()
    return items.every((it, idx)=> !it.is_required || this.isAgreed(idx))
  }

  renderConsents() {
    return this.getConsentItems().map((item, idx)=> {
      const title = `${item.text} <a style='color: #1E90FF' href='${item.link_url}' target='_blank'>${item.link_title}</a>`
      return (
        <CheckBoxComponent
          key={idx}
          title={title}
          value={this.isAgreed(idx)}
          onChange={()=> { this.toggleAgree(idx) }}
          cl="mt-10 checkbox--login-consent"
        />
      )
    })
  }

  render() {
    const st = this.state
    const canRefreshCode = this.canRefreshCode()
    const mask = sharedData.phone_mask

    return (
      <div>
        <DialogComponent opened={st.state == 'login'} onClose={this.props.onClose} width="auto" height="auto">
          <div className="login-box">
            <div className="h1">{this.props.ttl}</div>

            <form onSubmit={this.makeLogin}>

              { !st.sending_sms &&
                <div className="input"
                  ref={(r)=> { this.phoneWrapperRef = r }}
                >
                  <InputMask
                    className="input__text"
                    placeholder="Телефон"
                    type="text"
                    value={st.params.phone}
                    onChange={(e)=> { this.changeParams('phone', e) }}
                    mask={mask}
                  />

                  {this.renderConsents()}
                </div>
              }

              { st.sending_sms &&
                <div>
                  <div className="input">
                    <input
                      className={ "input__text " +
                        this.isError('code')
                      }
                      placeholder="Код из смс"
                      type="text"
                      ref={(r)=> { this.codeRef = r }}
                      value={st.params.code}
                      onChange={(e)=> { this.changeParams('code', e) }}
                    />
                  </div>
                </div>
              }

              { !st.sending_sms &&
                <button
                  className={ "btn btn--red " +
                    ((this.isValidPhone() && this.consentsOk()) ? '' : 'btn--disabled')
                  }
                  onClick={this.sendCode}>
                  Далее
                </button>
              }
              { st.sending_sms &&
                <div className="row">
                  <div className="col-xs-6">
                    <button
                      className={ "btn btn--red " +
                        (this.canSubmitCode() ? '' : 'btn--disabled')
                      }
                      onClick={this.login}
                    >Войти</button>
                  </div>
                  <div className="col-xs-6">
                    { canRefreshCode &&
                      <a className="login-small-hint" href='' onClick={this.refreshCode}>отправить код повторно</a>
                    }
                    { !canRefreshCode &&
                        <span className="login-sms-refresh-hint">
                        можно запросить повтор сообщения через { this.state.timer_seconds } сек
                        </span>
                    }

                    <br/>
                    <a className="" href='' onClick={this.cancelCode}>отмена</a>
                  </div>
                </div>
              }

            </form>
          </div>
        </DialogComponent>
      </div>
    )
  }
}



// WEBPACK FOOTER //
// ./app/javascript/website_default/js/react/profile/login/login_dialog.component.jsx